var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-card-btn-component CreateCardBtn"},[_c('button',{staticClass:"margin-l__10 btn btn__round btn__bordered",on:{"click":_vm.btnOnClick}},[_vm._v("\n        "+_vm._s(_vm.$t('BUTTON.CREATE_CARD'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }